<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    <v-container class="grey lighten-5">
        <p class="hidden-sm-and-down">
        <p class="hidden-md-and-up">
800 x 450
640 x 360
576 x 324
480 x 270
    -->
    <v-container class="">
      <span class="trace">NetZero.vue</span>
      <br>

        <h3>Net Zero Basics for Buildings</h3>
        <p class="mx-6">
        </p>
        <!-- xs -->
        <p class="d-sm-none">
        <span class="debug">xs<br></span>
        <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/457995875"
            width="480"
            height="270"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        />
        </p>
        <!-- sm -->
        <p class="d-none d-sm-flex d-md-none">
        <span class="debug">sm<br></span>
        <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/457995875"
            width="576"
            height="324"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        />
        </p>
        <!-- md -->
        <p class="d-none d-md-flex d-lg-none">
        <span class="debug">md<br></span>
        <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/457995875"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        />
        </p>
        <!-- lg -->
        <p class="d-none d-lg-flex d-xl-none">
        <span class="debug">lg<br></span>
        <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/457995875"
            width="800"
            height="450"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        />
        </p>
        <!-- xl -->
        <p class="d-none d-xl-flex">
        <span class="debug">xl<br></span>
        <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/457995875"
            width="960"
            height="540"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        />
        </p>

        <h6>Best viewed in Fullscreen mode</h6>

      <v-row v-if="1==0">
        <v-col
          md="10"
          offset-md="1"
        >
          <v-btn
            small
            class="mr-0 small"
            @click="wpClick"
          >
            Back to Water Protectors<span class="hidden-md-and-down">...</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'Adapt',

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    data: () => ({
      // maxW: 800,
      youTube: true,
      currentValue: 475000,
      nitrateIncreasePercentDefault: 15,
      valuePerNitrateFactor: 0.61,
      valuePerLow: 0.407,
      valuePerHigh: 0.807,
      recentNitrate: 2.3,
      previousNitrate: 2.0,
      calculate: false,
      ex1: { label: 'color', val: 25, color: 'red' },
    }),

    computed: {
      adjustedValue () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      adjustedValueLow () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      adjustedValueHigh () {
        const x = this.currentValue * (1 - 0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      adjustedValueCommas () {
        return this.adjustedValue.toLocaleString()
        // return Number(parseFloat(this.adjustedValue.toFixed(0).toLocaleString('en', { minimumFractionDigits: 0 })))
      },

      lostValue () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerNitrateFactor)
        return Math.round(x)
      },
      lostValueLow () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerLow)
        return Math.round(x)
      },
      lostValueHigh () {
        const x = this.currentValue * (-0.01 * this.nitrateIncreasePercent * this.valuePerHigh)
        return Math.round(x)
      },
      lostValueCommas () {
        return this.lostValue.toLocaleString()
      },

      nitrateIncreasePercent () {
        if (this.recentNitrate > 0 && this.previousNitrate > 0) {
          return Math.round(100 * (this.recentNitrate / this.previousNitrate - 1))
        } else return this.nitrateIncreasePercentDefault
      },

    },

    methods: {
      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
      sayMe: function (arg) {
        console.log(arg)
        // alert('ProjectCard.vue:' + this.graphic)
      },

    },

  }
</script>

<style scoped>
h3 {
  color: dodgerblue
}
h6 {
  color: gray
}
.debug {
  color: pink;
  font-size: 0%;
}
</style>
